import loadable from "@loadable/component"

export const SiteInformationView = loadable(() =>
  import(
    /* webpackChunkName: "site-information-chunk" */
    /* webpackPrefetch: true */
    "./components/SiteInformationView"
  ).then(mod => mod.SiteInformationView)
)
